import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Card} from '@vio/atlas/src/components/designSystem/Card'
import {Divider} from '@vio/atlas/src/components/designSystem/Divider'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {Room} from '@vio/core/src/room/types/room'

import {RoomDetailsMountComponent} from '../RoomCard/constants'
import {ExpandableRoomOffersToggle} from '../RoomCard/ExpandableRoomOffersToggle'
import {useExpandableListToggle} from '../RoomCard/useExpandableListToggle'
import {RoomOffer} from '../RoomOffer/RoomOffer'

interface Props {
  room: Room
  isMountedOnOverlay?: boolean
}

const DEFAULT_VISIBLE_OFFERS = 2

export const RoomOffersList = ({room, isMountedOnOverlay = false}: Props) => {
  const {isMobile, isDesktopXs} = useDeviceLayout()

  const {isOffersExpanded, toggleOffersExpanded} = useExpandableListToggle(
    room.id
  )

  const {offers} = room

  const isExpandToggleAvailable =
    !isMountedOnOverlay && room.offers.length > DEFAULT_VISIBLE_OFFERS
  const visibleOffersAmount = !isOffersExpanded
    ? DEFAULT_VISIBLE_OFFERS
    : room.offers.length

  const visibleOffers = offers?.slice(
    0,
    isExpandToggleAvailable ? visibleOffersAmount : room.offers.length
  )

  if (isMobile)
    return (
      <div>
        {visibleOffers.map((offer, index) => (
          <Box
            borderWidth="bw100"
            borderColor="border.neutral.secondary"
            borderStyle="solid"
            borderRadius="lg"
            padding="s500"
            margin="s400"
            marginBottom={index === visibleOffers.length - 1 ? 's0' : 's300'}
            marginTop="s300"
            height="100%"
            key={offer.id}
            data-id="room-offer-container"
          >
            <RoomOffer
              isVerticalLayout
              offer={offer}
              room={room}
              component={RoomDetailsMountComponent.HotelViewRoomsSection}
              offerIndex={index}
              isMountedOnOverlay={isMountedOnOverlay}
            />
          </Box>
        ))}
        {isExpandToggleAvailable && (
          <ExpandableRoomOffersToggle
            nextAvailableOffer={offers[DEFAULT_VISIBLE_OFFERS]}
            remainingCount={room.offers.length - 2}
            isExpanded={isOffersExpanded}
            onClick={toggleOffersExpanded}
          />
        )}
      </div>
    )

  return (
    <Card borderColorPath="border.neutral.secondary" borderRadius="lg">
      <Box>
        {visibleOffers.map((offer, index) => (
          <React.Fragment key={offer.id}>
            {index > 0 && <Divider />}
            <Box width="100%" padding="s600" data-id="room-offer-container">
              <RoomOffer
                isVerticalLayout={isMountedOnOverlay && !isDesktopXs}
                offer={offer}
                room={room}
                component={RoomDetailsMountComponent.HotelViewRoomsSection}
                offerIndex={index}
                isMountedOnOverlay={isMountedOnOverlay}
              />
            </Box>
          </React.Fragment>
        ))}
        {isExpandToggleAvailable && (
          <ExpandableRoomOffersToggle
            remainingCount={room.offers.length - 2}
            isExpanded={isOffersExpanded}
            onClick={toggleOffersExpanded}
          />
        )}
      </Box>
    </Card>
  )
}
